<template>
  <CardFrame :bgColor="data.backgroundColor" hasDropShadow>
    <CardContainer>
      <CardHeaderContainer>
        <Title class="text-center" :headingTag="'h3'" :style="'h3'">
          {{ data.title }}
        </Title>
      </CardHeaderContainer>
      <CardBodyContainer>
        <CardBody :textAlignment="'left'" :text="data.body"> </CardBody>
      </CardBodyContainer>
      <CardButtons :buttons="data.buttons"></CardButtons>
    </CardContainer>
  </CardFrame>
</template>

<script>
import CardBody from "../../Atoms/Cards/CardBody.vue";
import CardBodyContainer from "../../Atoms/Cards/CardBodyContainer.vue";
import CardButtons from "../../Atoms/Cards/CardButtons.vue";
import CardContainer from "../../Atoms/Cards/CardContainer.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import CardHeaderContainer from "../../Atoms/Cards/CardHeaderContainer.vue";
import Title from "../../Atoms/Heading.vue";

export default {
  components: {
    CardBody,
    CardBodyContainer,
    CardButtons,
    CardContainer,
    CardFrame,
    CardHeaderContainer,
    Title,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup() {},
};
</script>
